import { createSlice } from '@reduxjs/toolkit';

export const permissionSlice = createSlice({
  name: 'permission',
  initialState: {
    permissions: undefined,
  },
  reducers: {
    setPermission: (state, action) => {
      state.permissions = action.payload;
    },
    setMyTimeSheet: (state, action) => {
      state.myTimesheet = action.payload;
    },
    setdepartment: (state, action) => {
      state.department = action.payload;
    },
    setquailification: (state, action) => {
      state.qualification = action.payload;
    },
    setdesignation: (state, action) => {
      state.designation = action.payload;
    },
    setleave: (state, action) => {
      state.leave = action.payload;
    },
    setEmail: (state, action) => {
      state.email = action.payload;
    },
    setSurveyCategory: (state, action) => {
      state.surveyCategory = action.payload;
    },
    setSurveyPeriod: (state, action) => {
      state.surveyPeriod = action.payload;
    },
    setSurvey: (state, action) => {
      state.survey = action.payload;
    },
    setSurveyCreate: (state, action) => {
      state.surveyCreate = action.payload;
    },
    setMysurvey: (state, action) => {
      state.mysurvey = action.payload;
    },
    setApprovals: (state, action) => {
      state.approvals = action.payload;
    },
    setTrainings: (state, action) => {
      state.trainings = action.payload;
    },
    setUser: (state, action) => {
      state.user = action.payload;
    },
    setUserRole: (state, action) => {
      state.userRole = action.payload;
    },
    setProject: (state, action) => {
      state.project = action.payload;
    },
    setModule: (state, action) => {
      state.module = action.payload;
    },
    setSettings: (state, action) => {
      state.settings = action.payload;
    },
    setUserLog: (state, action) => {
      state.userlog = action.payload;
    },
    setAttendance: (state, action) => {
      state.attendance = action.payload;
    },
    setSettingPermission: (state, action) => {
      state.settingPermission = action.payload;
    },
    setVariance: (state, action) => {
      state.variance = action.payload;
    },
    setUsersTimesheet: (state, action) => {
      state.userTimesheet = action.payload;
    },
    setMyLeave: (state, action) => {
      state.myLeave = action.payload;
    },
    setUserLeave: (state, action) => {
      state.userLeave = action.payload;
    },
    setMyPermission: (state, action) => {
      state.myPermission = action.payload;
    },
    setUserPermission: (state, action) => {
      state.userPermission = action.payload;
    },
    setNotificationHistory: (state, action) => {
      state.notificationHistory = action.payload;
    },
    setDepartmentReport: (state, action) => {
      state.departmentReport = action.payload;
    },
    setUserReport: (state, action) => {
      state.userReport = action.payload;
    },
    setSurveyReport: (state, action) => {
      state.surveyReport = action.payload;
    },
    setSkillMatrix: (state, action) => {
      state.skillMatrix = action.payload;
    },
    setEmployeesReview: (state, action) => {
      state.employeeReview = action.payload;
    },
    setQuestionBank: (state, action) => {
      state.questionBank = action.payload;
    },
    setDashboard: (state, action) => {
      state.dashboard = action.payload;
    },
    setSurveyDasboard: (state, action) => {
      state.surveyDashboard = action.payload;
    },
  },
});

export const {
  setPermission,
  setMyTimeSheet,
  setdepartment,
  setquailification,
  setdesignation,
  setleave,
  setEmail,
  setSurveyCategory,
  setMysurvey,
  setSurveyPeriod,
  setQuestionBank,
  setSurvey,
  setSurveyCreate,
  setApprovals,
  setTrainings,
  setUser,
  setUserRole,
  setProject,
  setModule,
  setSettings,
  setUserLog,
  setAttendance,
  setSettingPermission,
  setVariance,
  setUsersTimesheet,
  setMyLeave,
  setUserLeave,
  setNotificationHistory,
  setDepartmentReport,
  setUserReport,
  setSurveyReport,
  setSkillMatrix,
  setDashboard,
  setSurveyDasboard,
  setMyPermission,
  setUserPermission,
  setEmployeesReview,
} = permissionSlice.actions;

export const getPermission = (state) => state.permission.permissions;
export const getMyTimeSheet = (state) => state.permission.myTimesheet;
export const getDepartment = (state) => state.permission.department;
export const getQualification = (state) => state.permission.qualification;
export const getLeave = (state) => state.permission.leave;
export const getEmail = (state) => state.permission.email;
export const getSurveyCategory = (state) => state.permission.surveyCategory;
export const getSurvey = (state) => state.permission.survey;
export const getSurveyCreate = (state) => state.permission.surveyCreate;
export const getMysurvey = (state) => state.permission.mysurvey;
export const getSurveyPeriod = (state) => state.permission.surveyPeriod;
export const getQuestionBank = (state) => state.permission.questionBank;
export const getApprovals = (state) => state.permission.approvals;
export const getTrainings = (state) => state.permission.trainings;
export const getUser = (state) => state.permission.user;
export const getUserRole = (state) => state.permission.userRole;
export const getProjects = (state) => state.permission.project;
export const getModules = (state) => state.permission.module;
export const getDesignation = (state) => {
  return state.permission.designation;
};
export const getSettings = (state) => {
  return state.permission.settings;
};
export const getUserLog = (state) => {
  return state.permission.userlog;
};
export const getAttendance = (state) => {
  return state.permission.attendance;
};

export const getSettingPermission = (state) => {
  return state.permission.settingPermission;
};

export const getVariance = (state) => {
  return state.permission.variance;
};
export const getUsersTimesheet = (state) => {
  return state.permission.userTimesheet;
};
export const getMyLeave = (state) => {
  return state.permission.myLeave;
};
export const getUserLeave = (state) => {
  return state.permission.userLeave;
};

export const getMyPermission = (state) => {
  return state.permission.myPermission;
};
export const getUserPermission = (state) => {
  return state.permission.userPermission;
};

export const getNotificationHistory = (state) => {
  return state.permission.notificationHistory;
};
export const getDepartmentReport = (state) => {
  return state.permission.departmentReport;
};

export const getUserReport = (state) => {
  return state.permission.userReport;
};
export const getSurveyReport = (state) => {
  return state.permission.surveyReport;
};
export const getSkillMatrix = (state) => {
  return state.permission.skillMatrix;
};
export const getEmployeesReview = (state) => {
  return state.permission.employeeReview;
};
export const getDashboard = (state) => {
  return state.permission.dashboard;
};

const extractAction = () => {};

export function setSettingsData(data) {
  return async function (dispatch) {
    dispatch(setSettings(data));
  };
}

export function getCheckPermission(data) {
  return async function (dispatch) {
    for (const element of data) {
      if (element?.statename === 'settings') {
        dispatch(setSettingPermission(element));
      }
      if (element?.statename === 'userlog') {
        dispatch(setUserLog(element));
      }
      if (element?.statename === 'surveyCreate') {
        dispatch(setSurveyCreate(element));
      }
      if (element?.statename === 'dashboard') {
        dispatch(setDashboard(element));
      }
      if (element?.statename === 'approvals') {
        dispatch(setApprovals(element));
      }
      if (element?.statename === 'mysurvey') {
        dispatch(setMysurvey(element));
      }

      if (element?.children) {
        for (const children of element?.children) {
          switch (children?.statename) {
            case 'myTimesheet':
              dispatch(setMyTimeSheet(children));
              break;
            case 'department':
              dispatch(setdepartment(children));
              break;
            case 'qualification':
              dispatch(setquailification(children));
              break;
            case 'designation':
              dispatch(setdesignation(children));
              break;
            case 'leave':
              dispatch(setleave(children));
              break;
            case 'emailNotification':
              dispatch(setEmail(children));
              break;
            case 'category':
              dispatch(setSurveyCategory(children));
              break;
            case 'period':
              dispatch(setSurveyPeriod(children));
              break;
            case 'questionBank':
              dispatch(setQuestionBank(children));
              break;
            case 'survey':
              dispatch(setSurvey(children));
              break;
            case 'trainings':
              dispatch(setTrainings(children));
              break;
            case 'user':
              dispatch(setUser(children));
              break;
            case 'userRole':
              dispatch(setUserRole(children));
              break;
            case 'project':
              dispatch(setProject(children));
              break;
            case 'module':
              dispatch(setModule(children));
              break;
            case 'attendance':
              dispatch(setAttendance(children));
              break;
            case 'effortVariance':
              dispatch(setVariance(children));
              break;
            case 'usersTimeSheet':
              dispatch(setUsersTimesheet(children));
              break;
            case 'myRequest':
              dispatch(setMyLeave(children));
              break;
            case 'userRequest':
              dispatch(setUserLeave(children));
              break;
            case 'notificationHistory':
              dispatch(setNotificationHistory(children));
              break;
            case 'departmentReport':
              dispatch(setDepartmentReport(children));
              break;
            case 'userReport':
              dispatch(setUserReport(children));
              break;
            case 'surveyReport':
              dispatch(setSurveyReport(children));
              break;
            case 'skillMatrix':
              dispatch(setSkillMatrix(children));
              break;
            case 'employees':
              dispatch(setEmployeesReview(children));
              break;
            case 'surveyDashboard':
              dispatch(setSurveyDasboard(children));
              break;
            case 'myRequestPermission':
              dispatch(setMyPermission(children));
              break;
            case 'userRequestPermission':
              dispatch(setUserPermission(children));
              break;
            default:
              break;
          }
        }
      }
    }
  };
}

export default permissionSlice.reducer;
